<template>
  <div>
    <div class="mb-6">
      <SegmentSelector v-model="segment" />
    </div>

    <HorizontalBarChart bar-class="bg-secondaryYellow" :data="barData" />
  </div>
</template>

<script>
import HorizontalBarChart from "@/components/HorizontalBarChart";
import data from "@/assets/data/data";
import IDS from "@/utils/ids";
import SegmentSelector from "@/components/SegmentSelector";

export default {
  components: { HorizontalBarChart, SegmentSelector },
  props: {
    question: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      data: data[this.question].filter((e) => e[IDS.QUESTION_SUBNUMBER] === ""),
      segment: "TOTAL",
      questionText: data[this.question][0][IDS.QUESTION_MAIN],
    };
  },
  computed: {
    barData() {
      return this.data
        .map((e) => ({
          name: e[IDS.ANSWER],
          value: e[IDS[this.segment]],
          compare: null,
        }))
        .sort((a, b) => b.value - a.value);
    },
  },
  watch: {
    segment(val) {
      this.$emit("changeSegment", val);
    },
  },
};
</script>
